import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'ng2-file-upload';

import { DocumentService } from './document.service';
import { DocumentsResolver } from './documents.resolver';
import { DocumentResolver } from './document.resolver';
import { DocumentListComponent } from './document-list.component';
import { DocumentEditComponent } from './document-edit.component';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    FileUploadModule
  ],
  declarations: [
    DocumentListComponent,
    DocumentEditComponent
  ],
  providers: [
    DocumentService,
    DocumentsResolver,
    DocumentResolver
  ],
})
export class DocumentModule { }
